import {
  Box,
  Flex,
  Heading,
  HStack,
  Image,
  Text,
  IconButton,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { FaDownload } from "react-icons/fa6";
import { API_URL } from "constants";

export default function Header({ generatedScenes, projectId }) {
  const [loadingXML, setLoadingXML] = useState(false);
  const toast = useToast();

  const handleDownloadAllXML = async () => {
    if (!generatedScenes || generatedScenes.length === 0) {
      toast({
        title: "Download failed",
        description: "No scenes available for download",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-right",
      });
      return;
    }

    setLoadingXML(true);
    try {
      console.log("Starting XML export for all scenes");

      // Make the request manually to handle the response properly
      const response = await fetch(`${API_URL}/v2/${projectId}/xml/export`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          scene_names: generatedScenes.map((scene) => scene.scene_name),
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Get the response as text first
      const xmlText = await response.text();
      console.log("XML response text:", xmlText.substring(0, 200) + "...");

      // Create a blob from the XML text
      const blob = new Blob([xmlText], {
        type: "application/xml; charset=utf-8",
      });

      // Create a URL for the blob
      const url = URL.createObjectURL(blob);

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = url;
      link.download = `all-scenes.xml`;

      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the URL
      URL.revokeObjectURL(url);

      toast({
        title: "Download successful",
        description: `All scenes XML downloaded successfully`,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "bottom-right",
      });
    } catch (error) {
      console.error("XML export error:", error);
      console.error("Error details:", {
        message: error.message,
        status: error.status,
        data: error.data,
        originalStatus: error.originalStatus,
      });

      const errorMessage =
        error?.data?.message ||
        error?.message ||
        error?.status ||
        "Unknown error occurred";

      toast({
        title: "Download failed",
        description: `Failed to download XML: ${errorMessage}`,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-right",
      });
    } finally {
      setLoadingXML(false);
    }
  };

  return (
    <Flex
      alignItems="center"
      bg="gray.200"
      color="gray.700"
      height="60px"
      justifyContent="space-between"
      left={0}
      p={4}
      position="fixed"
      right={0}
      top={0}
      width="100%"
      zIndex={10}
    >
      <HStack spacing={8}>
        <Image alt="Magic Seven Logo" h="60px" src="/logo.png" w="60px" />
        <HStack>
          <Heading
            as="h1"
            fontFamily="'Ms Madi', serif"
            fontSize="3xl"
            fontWeight="500"
          >
            John and Jane&apos;s Wedding
          </Heading>
          <Box>
            <Text fontSize="xs" mt="12px">
              by MagicSeven
            </Text>
          </Box>
        </HStack>
      </HStack>

      {/* XML Export Button */}
      {generatedScenes && generatedScenes.length > 0 && (
        <IconButton
          aria-label="Download all scenes XML"
          borderRadius="md"
          colorScheme="green"
          icon={
            loadingXML ? (
              <Spinner size="xs" />
            ) : (
              <>
                <FaDownload size="12px" />{" "}
                <Text fontSize="10px" ml={1}>
                  XML
                </Text>
              </>
            )
          }
          isLoading={loadingXML}
          onClick={handleDownloadAllXML}
          pl={2}
          pr={2}
          size="sm"
          title="Download all scenes XML"
        />
      )}
    </Flex>
  );
}
